import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import { useForm } from "react-hook-form";
import { enviarHoraExtraGerencia } from "../../../NominaHorasExtras/services/horas-extras-service";
import { useContext } from "react";
import BtnEnviarHorasExtrasContext from "../../store/boton-enviar-horas-extras-context";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormEnviarHorasExtras = ({ modalState, onHorasExtras}) => {
    const { actualizarBotonHorasExtras } = useContext(
        BtnEnviarHorasExtrasContext
    );
    const onSubmit = async (formData) => {
        const form = new FormData();
        form.append(
            "observacion_envio_gerencia",
            formData.observacion_envio_gerencia
        );

        const resp = await enviarHoraExtraGerencia(form);
        if (!resp.status) return toast.error(resp.message);

        actualizarBotonHorasExtras();
        modalState.set({ show: false });
        toast.success("Se enviaron las horas extras");
        onHorasExtras ? onHorasExtras() : false;
    };

    const form = useForm();

    return (
        <FormModal
            size="lg"
            form={form}
            onSubmit={onSubmit}
            isOpen={modalState.show}
            id="formEnviarHoraExtra"
            headerTitle="Enviar Hora Extra a Gerencia"
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <Col lg={12}>
                    <InputController
                        type="textarea"
                        label="Observaciones generales"
                        name="observacion_envio_gerencia"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormEnviarHorasExtras.propTypes = {
    modalState: PropTypes.object,
    onHorasExtras: PropTypes.func,
};

export default FormEnviarHorasExtras;
